import { SupabaseClient } from '@supabase/supabase-js';
import camelcaseKeys from 'camelcase-keys';

import { Database, withLogs } from '@core';

export type CategoryType = 'metric' | 'graph_type' | 'body_part' | 'item_part' | 'swing_foundation_group';
export type Category = {
    id: string;
    displayOrder: number;
    type: CategoryType;
    i18n: string | null;
};

export const fetchCategories = withLogs(
    async (
        supabase: SupabaseClient<Database>,
        type?: 'metric' | 'graph_type' | 'body_part' | 'item_part' | 'swing_foundation_group',
    ): Promise<Category[]> => {
        let query = supabase.from('ui_node_categories').select('*').order('display_order');
        if (type) {
            query = query.eq('type', type);
        }
        const { data, error } = await query;

        if (error) {
            console.error('error fetching ui_node_categories:', error);
            return [];
        }

        const categories = camelcaseKeys(data, { deep: true });

        return categories.map((category) => {
            return {
                id: category.id,
                displayOrder: category.displayOrder,
                type: category.type,
                i18n: category.i18N,
            };
        });
    },
    'fetchCategories',
);
